export default __webpack_public_path__ + "static/media/bitbucket.399c0812.svg";